import * as moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import { doGetResultsPDF, fetchLabResultsThunk } from '../actions/api'
import CovidInfo from '../components/covidInfo'
import ImportantInfo from '../components/importantInfo'
import RecentResults from '../components/recentResult'
import * as settings from '../globals/settings'
import test from '../images/ic-results.png'
import pdf from '../images/pdf-icon.png'
import refresh from '../images/refresh.png'
import ResultBoxUser from './resultBoxUser'

import { Modal } from 'react-bootstrap'
import { setSelectedLabResult } from '../actions/api'
import { PENDING } from '../api/mappers/labResultMapper'
import BackButton from '../components/backButton'
import { formatDate } from '../util/util'

class ResultBox extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isDropDownOpen: false,
            showModal: false,
        }
    }

    toggleDropDown = () => {
        this.setState({ isDropDownOpen: !this.state.isDropDownOpen });
    }

    componentDidMount() {
        if (this.props.labResults != null) {
            this.props.dispatch(setSelectedLabResult(this.props.labResults[0]));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.labResults != null && prevProps.selectedLabResult === null && prevProps.labResults === null) {
            this.props.dispatch(setSelectedLabResult(this.props.labResults[0]));
        }
    }

    handleMessage(event, l){
        this.props.dispatch(setSelectedLabResult(l));
    }

    renderNoResults() {
        return (
            <div className="row">
                <div className="col-12">
                    {this.props.strings.NO_RESULT}
                </div>
            </div>
        );
    }

    renderRecentResults() {
        if (this.props.selectedLabResult != null) {
            return <RecentResults language={this.props.language} strings={this.props.strings} result={this.props.selectedLabResult.result} rawResult={this.props.selectedLabResult.rawResult} type={this.props.selectedLabResult.type} date={this.props.selectedLabResult.date}/>
        } else {
            return null;
        }
    }

    renderTwoWeeksMessage = () => {
        if(this.props.labResults === null || this.props.labResults === undefined || this.props.labResults === "" || this.props.labResults.length === 0){ return null; }

        let showMessage = false;
        for (let i = 0; i < this.props.labResults.length; i++) {
            let resultDate = moment(this.props.labResults[i].date);
            let today = moment();
            let twoWeeks = today.subtract(14, "days");
            if(resultDate.isBefore(twoWeeks)){
                showMessage = true;
            } else {
                showMessage = false;
                break;
            }
        }
        if(showMessage){
            return (<div className="twoWeeks"><h6>{this.props.strings.TWO_WEEKS_OLD}</h6></div>);
        } else {
            return null;
        }
    }

    refreshResults = () => {
      let userId = null;
        if(this.props.selectedUser.isDependent){
            userId=this.props.selectedUser.id;
        }

        //TODO NEED to load page first before pushing to results or load on next page with spinner
        if(this.props.isFakeLoggedIn === false || this.props.isFakeLoggedIn===undefined || this.props.isFakeLoggedIn === null){
            this.props.dispatch(fetchLabResultsThunk(userId));
        }
    }

    renderPDFButton = () => {
        if(this.props.labResults === null || this.props.labResults === undefined || this.props.labResults === "" 
            || this.props.labResults.length === 0 || this.props.selectedLabResult === null 
                ||this.props.selectedLabResult === undefined ||this.props.selectedLabResult.date === null 
                    || this.props.selectedLabResult.date === undefined){ return null; }
        
        let today = moment();
        let button = null;
        let resultDate = moment(this.props.selectedLabResult.date);
        let numDaysLimit = settings.PDF_DATE_LIMIT;
        let limitDay = today.subtract(numDaysLimit, "days");
        if(resultDate.isBefore(limitDay)){
            button = null;
        } else {
            button = (
                <div className="pdf order-sm-2 col-4-lg">
                    <button className="btn btn-pdf" disabled={this.props.isGettingPDF} onClick={this.openPDFModal}>
                        <img className="pdf-icon" src={pdf} width="18"/>{this.props.strings.DOWNLOAD_PDF}
                    </button>
                </div>
            );
        }
        return button;
    }

    openPDFModal=()=>{
        this.setState({showModal:true});
    }
    closePDFModal=()=>{
        this.setState({showModal:false});
    }

    renderModal=()=>{
        if(this.state.showModal === true){
            return(
                <Modal
                        size="md"
                        show={this.state.showModal}
                        centered={true}
                        scrollable={true}
                    >
                        <Modal.Body>
                            <h3><i><u><strong>{this.props.strings.PDF_CONFIRM_HEADER}</strong></u></i></h3>
                            <h6>{this.props.strings.PDF_CONFIRM_MESSAGE_1}
                                <i><u>{this.props.strings.PDF_CONFIRM_MESSAGE_2}</u></i>
                                {this.props.strings.PDF_CONFIRM_MESSAGE_3}
                            </h6>
                        </Modal.Body>
                        <Modal.Footer className="regModal">
                            <div>
                                <button type="button" class="btn btn-primary custom-button" onClick={ () => this.onClickPDF()} >{this.props.strings.PDF_POPUP_CONFIRM}</button>
                                <button type="button" class="btn btn-secondary custom-button" onClick={ () => this.closePDFModal()} >{this.props.strings.PDF_POPUP_CANCEL}</button>
                            </div>
                        </Modal.Footer>
                    </Modal>
            )
        }
    }

    onClickPDF =()=>{
        let unparsedDate = moment(this.props.selectedLabResult.date);
        let resultDate = unparsedDate.format("YYYY-MM-DD");
        let messageId = this.props.selectedLabResult.messageId;
        let facilityNumber = this.props.selectedLabResult.facilityNumber;
        let userId= null;
        if(this.props.selectedUser.isDependent){
            userId = this.props.selectedUser.id;
        }

        this.props.dispatch(doGetResultsPDF(messageId,facilityNumber,resultDate, userId));
        this.closePDFModal();
    }

    render() {
        if (this.props.labResults != null) {
            let title = this.props.strings.NO_RESULT;
            if (this.props.selectedLabResult != null && this.props.selectedLabResult.result !== PENDING) {
                title = formatDate(this.props.selectedLabResult.date, this.props.language);
            }
            let labDropDownOptions = this.props.labResults.map((l, index) => {
                // FIXME This only works because we have one noresult!
                if (l.result === PENDING) {
                    return <a key={index} class="dropdown-item">{title}</a>
                } else {
                    return <a key={index} class="dropdown-item" onClick={(event) => this.handleMessage(event, l)}>{formatDate(l.date, this.props.language)}</a>
                }
            });
			let menuClass = "dropdown-menu w-100"
			if (this.state.isDropDownOpen === true) {
				menuClass = menuClass + " show";
			}

            return (
                <div className="col-12 col-lg-8 col-md-12 order-1 order-sm-1 order-md-1 order-lg-1">
                    {this.renderModal()}
                    <div className="row">
                    <div className="col-12">
                        <div className="testName">
                            <div class="testIcon"><img src={test} width="25" /></div>
                            <h4>{this.props.strings.RESULT_BOX_HEADER}</h4>
                            <div className="row">
                                <div className="col-12">
                                    <div className="subNav">
                                        <div className="refresh order-sm-1 col-4-lg"><button onClick={this.refreshResults} className="btn btn-success"> <img src={refresh} width="22" />{this.props.strings.REFRESH_RESULTS}</button></div>
                                        <div className="d-none d-lg-inline"><BackButton /></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ResultBoxUser/>
                        <div className="selectTest">
                            <h5>{this.props.strings.HISTORIC_TEST_HEADER}</h5>
                            <p>{this.props.strings.VIEW_YOUR_RESULTS_BODY}</p>
                            <div className="dropdown" onClick={this.toggleDropDown}>
                                <a className="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {title}
                                </a>
                                <div className={menuClass} aria-labelledby="dropdownMenuLink">
                                    {labDropDownOptions}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*TODO Add the results are over 2 weeks old */}
                {this.renderTwoWeeksMessage()}
                <div className="information"></div>
                    {this.renderRecentResults()}
                    {this.renderPDFButton()}
                    <ImportantInfo isResults={true} isModal={false} />
                    <div class="alert alert-info hideMobile" role="alert">
                        <CovidInfo />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="col-12 col-lg-8 col-md-12 order-1 order-sm-1 order-md-1 order-lg-1">
                    <div className="d-none d-lg-inline"><BackButton /></div>
                    <div className="ml-3">{this.renderNoResults()}</div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        labResults: state.api.labResults,
        strings: state.language.strings,
        language: state.language.language,
        selectedLabResult: state.api.selectedLabResult,
        selectedUser: state.api.selectedUser,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isGettingPDF: state.api.isGettingPDF,
    }
}

const ConnectedResultBox = connect(
    mapStateToProps
)(ResultBox);
export default ConnectedResultBox;
